// extracted by mini-css-extract-plugin
module.exports = {"deleteBtn":"schedule_table_deleteBtn__Tsufr","viewButton":"schedule_table_viewButton__2FDqM"};